export enum FieldType {
  IntegerField,
  FloatField,
  StringField,
  PasswordField,
  HiddenField,
  ObjectField,
  ForeignSourceField,
  ImmutableListField,
  TypeaheadField,
  InputArrayField,
  BooleanField,
  SwitchBooleanField,
  FancyBooleanField,
  DateTimeField,
  DateTimeRangeField,
  DurationDaysField,
  DurationMinutesField,
  ReflexiveModelField,
  ImageField,
  AudioField,
  ImportField,
  DateField,
  HtmlColorField,
  SelectField,
  ReflexiveModelArrayField,
  ReflexiveModelArrayColumnField,
  ReflexiveModelObjectField,
  ReflexiveDragArrayField,
  VariationArrayField,
  MapCoordinateField,
  MapPointField,
  TimeField,
  MapUnitLatLngField,
  RowSelectionField,
  GridColumnRowSelectionField,
  TemplateData,
  PermissionListField,
  InfoData
}
